import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <span className="logo-text">Ritesh Gajjar</span>
          <span className="logo-emoji">📊</span>
        </div>
        
        <div className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
          <ul className="navbar-links">
            <li>
              <Link to="/" className={location.pathname === "/" ? "active" : ""}>
                <span className="link-emoji">🏠</span> Home
              </Link>
            </li>
            <li>
              <Link to="/about" className={location.pathname === "/about" ? "active" : ""}>
                <span className="link-emoji">👨‍💻</span> About
              </Link>
            </li>
            <li>
              <Link to="/skills" className={location.pathname === "/skills" ? "active" : ""}>
                <span className="link-emoji">🛠️</span> Skills
              </Link>
            </li>
            <li>
              <Link to="/projects" className={location.pathname === "/projects" ? "active" : ""}>
                <span className="link-emoji">🚀</span> Projects
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>
                <span className="link-emoji">📞</span> Contact
              </Link>
            </li>
            <li className="cta-item">
              <a
                href="https://wa.me/918980614160?text=Hello%20Ritesh%2C%20I%E2%80%99m%20contacting%20you%20regarding%20your%20portfolio."
                className="cta-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="button-emoji">🌟</span> Connect with me
              </a>
            </li>
          </ul>
        </div>

        <button 
          className={`hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;